import {Component} from '@angular/core';
import {environment} from '../../../../environments/environment';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent {
  identityProviderUrl = environment.identityProviderUrl;
  gprUserPortalBaseUrl = environment.gprUserPortalBaseUrl;

  constructor() {
  }

}
